import React from "react";
import { toast } from "react-toastify";
import {connect} from "react-redux";
import { Link } from 'react-router-dom';
import Loader from 'react-loader-spinner';
import Header from "../../components/Headers/Header";
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  Input,
  Alert,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Container
} from "reactstrap";

import FormValidator from "../../lib/Rules/FormValidator";
import Rules from "../../lib/Rules/FormRules";
import InputError from "../../components/Elements/InputError";

import { createAdditionalService, updateAdditionalServiceLogo } from '../../actions/Services';
import UploadableImage from '../../components/Elements/UploadableImage/UploadableImage';

class AddAdditionalService extends React.Component {
    constructor(props){
        super(props);   

        this.validator = new FormValidator(Rules.addAdditionalService);
        
        this.state = {
            isLoading: false,
            name : '',
            description : '',
            longDescription : '',
            price : '',
            timeDescription: '',
            status: false,
            err:false,
            success:false,
            service_id: '',
            logo: null,
            logoReady: false,
            validation: this.validator.valid(),
        }

        this.handleImageChange = this.handleImageChange.bind(this);
        this.uploadLogoPhoto = this.uploadLogoPhoto.bind(this);
    }

    onSubmit(e){
        e.preventDefault();
        const {service_id, name,description, longDescription, price,timeDescription, status} = this.state;

        const validation = this.validator.validate(this.state);
        this.setState({ validation });
        this.submitted = true;

        if (validation.isValid) {
            this.setState({ isLoading:true });
            createAdditionalService(
                {
                    "status": false,
                    "name": name,
                    "description": description,
                    "longDescription": longDescription,
                    "price": price,
                    "timeDescription": timeDescription,
                    "service_id": service_id
                }
            ).then(response => {
                console.log(response);
                if(response.data.success.data){
                    this.uploadLogoPhoto(response.data.success.data);
                }else{
                    this.setState({err:true,message:'Unable to add!',isLoading:false}); toast.error('Unable to add!');
                    setTimeout(() =>{
                        this.setState({err:false,success:false,isLoading:false});
                    },3000);
                }
            }).catch(error=> {
                this.setState({err:true,message:'Server Error!'});
                setTimeout(() =>{
                    this.setState({err:false,success:false,isLoading:false});
                },3000);
            });
        }
    }

    uploadLogoPhoto({ _id }) {
        const { logo } = this.state;
        let payload = new FormData();
        payload._id = _id;
        payload.append('picture', logo);
        updateAdditionalServiceLogo(payload ).then(response => {
            if (response.data.success.data) {
                this.setState({err:false,success:true,message:'Additional service have been successfully added!'}); toast.success('Additional service have been successfully added!');
                setTimeout(()=>{
                    this.setState({isLoading:false});
                    this.props.history.push("/dashboard/service-additional");
                },3000)
            } else{
                this.setState({err:true,message:'Successfully added but failed to upload additional service logo! Please edit its logo!'}); toast.warn('Successfully added but failed to upload additional service logo! Please edit its logo!');
                setTimeout(() =>{
                    this.setState({err:false,isLoading:false});
                    this.props.history.push("/dashboard/service-additional");
                },3000);
            }
        }).catch(error => {
            this.setState({ err:true, message: 'Successfully added but server error when uploading logo! Please edit its logo!' });
            setTimeout(() =>{
                this.setState({err:false,isLoading:false});
                this.props.history.push("/dashboard/service-additional");
            },3000);
        });
    }

    handleImageChange(imageFile) {
        this.setState({
            logo: imageFile,
            logoReady: !!imageFile // cast to bool
        });
    }

    componentWillMount(){
        if(this.props.ServiceReducer.serviceData){
            this.setState({
                'service_id': this.props.ServiceReducer.serviceData._id
            })
        }
    }

    onChange(e){
        const {name, value} = e.target;
        this.setState({[name]: value});
    } 

    isNotFilled(){
        const {name,description, longDescription, price,timeDescription} = this.state;
        return (
            name === '' || 
            description === '' ||
            longDescription === '' ||
            price === '' ||
            timeDescription === ''
        )
    }

  render() {
    let {err,success, message, name,description, longDescription, price,timeDescription, isLoading} = this.state;
    let validation = this.submitted ? this.validator.validate(this.state):this.state.validation;
    return (
     <>
        <Header />
        {/* Table */}
        <Container className="mt--7" fluid>
            <Row>
                <Col sm="12" md="12">
                    <Card className="bg-secondary shadow">
                        <CardHeader className="bg-white border-0">
                            <Row className="align-items-center">
                            <Col xs="8">
                                <h3 className="mb-0">Add Additional Service</h3>
                            </Col>
                            <Col className="text-right" xs="4">
                                <Link to="/dashboard/service-additional">
                                    <Button
                                        color="primary"
                                        size="sm"
                                    >
                                    Back to Addtional Services
                                    </Button>
                                </Link>
                            </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Form role="form" method="POST">
                                <div className="pl-lg-4">
                                    <Row>
                                        <Col md="6" sm="12">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-name"
                                                >
                                                    Name*
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    id="input-fname"
                                                    placeholder="Enter a name"
                                                    type="text"
                                                    name="name"
                                                    onChange={this.onChange.bind(this)} 
                                                />
                                                <InputError show={validation.name.isInvalid} message={validation.name.message} />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6" sm="12">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-price"
                                                >
                                                    Price*
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    id="input-price"
                                                    placeholder="Enter a Price"
                                                    type="text"
                                                    name="price"
                                                    onChange={this.onChange.bind(this)} 
                                                />
                                                <InputError show={validation.price.isInvalid} message={validation.price.message} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md="6" sm="12">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-description"
                                                >
                                                    Description*
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    id="input-description"
                                                    placeholder="Enter a Description"
                                                    type="textarea"
                                                    name="description"
                                                    onChange={this.onChange.bind(this)} 
                                                />
                                                <InputError show={validation.description.isInvalid} message={validation.description.message} />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6" sm="12">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-longDescription"
                                                >
                                                    Long Description
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    id="input-longDescription"
                                                    placeholder="Enter a Long Description"
                                                    type="textarea"
                                                    name="longDescription"
                                                    onChange={this.onChange.bind(this)} 
                                                />
                                                <InputError show={validation.longDescription.isInvalid} message={validation.longDescription.message} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md="6" sm="12">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-timeDescription"
                                                >
                                                    Time Description*
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    id="input-timeDescription"
                                                    placeholder="Enter a Time Description"
                                                    type="text"
                                                    name="timeDescription"
                                                    onChange={this.onChange.bind(this)} 
                                                />
                                                <InputError show={validation.timeDescription.isInvalid} message={validation.timeDescription.message} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="12">
                                            <FormGroup>
                                                <label className="form-control-label" htmlFor="logo">
                                                    Logo*
                                                </label>
                                                <UploadableImage
                                                  uploadable={ true }
                                                  onChange={this.handleImageChange}
                                                />
                                                <InputError show={validation.logoReady.isInvalid} message={validation.logoReady.message} />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col sm="12">
                                            <div className="text-right">
                                                { !isLoading &&  
                                                    <Button className="mt-4" onClick={this.onSubmit.bind(this)} color="primary" type="button">
                                                        Submit
                                                    </Button>
                                                }
                                                {
                                                    isLoading && <Loader type="Circles" color="#5e72e4" height={30} width={30} />
                                                }
                                            </div>
                                        </Col>
                                    </Row> 
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    </>
    );
  }
}
const mapStateToProps = (state) =>({
    ...state
})

const mapDispatchToProps = (dispatch) =>({

})

export default connect(mapStateToProps, mapDispatchToProps)(AddAdditionalService);
